// ✅ FILE: components/FAQs.jsx

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const FAQs = () => {
  const faqs = [
    {
      question: 'Who is eligible to apply for a loan with Loanonsalary?',
      answer: 'Salaried individuals aged between 21 and 55, with a stable monthly income and valid KYC documents (Aadhaar and PAN), are eligible to apply.',
    },
    {
      question: 'What documents do I need to submit for a loan application?',
      answer: 'The process is paperless. You generally need to provide your PAN card, Aadhaar number for e-KYC, and your latest bank statement showing salary credits.',
    },
    {
      question: 'How long does it take to get loan approval?',
      answer: 'Our AI-driven system processes applications in real-time. Approval typically takes a few minutes, and disbursement happens shortly after the digital agreement is signed.',
    },
    {
      question: 'What is the maximum loan amount I can apply for?',
      answer: 'We offer short-term loans ranging from ₹5,000 to ₹1,00,000, depending on your monthly take-home salary and credit assessment.',
    },
    {
      question: 'What interest rates does Loanonsalary charge?',
      answer: 'We charge a transparent interest rate of 1% per day (30% per month). The Annual Percentage Rate (APR) ranges up to 365% depending on the loan structure.',
    },
    {
      question: 'Can I repay my loan before the tenure ends?',
      answer: 'Yes! We encourage early repayment. You can close your loan anytime before the due date without any prepayment or foreclosure penalties.',
    },
    {
      question: 'Is my personal data safe with Loanonsalary?',
      answer: 'Data security is our top priority. We use high-level encryption and follow strict RBI data privacy guidelines to ensure your information remains confidential.',
    },
    {
      question: 'What happens if I miss a repayment deadline?',
      answer: 'Missing a payment may result in a late fee of up to 0.75% per day on the overdue amount and can negatively impact your CIBIL score. We recommend contacting our support team if you face financial difficulties.',
    },
    {
      question: 'Are there any hidden charges?',
      answer: 'No. All charges, including the processing fee and interest rate, are clearly mentioned in the Key Fact Statement (KFS) before you sign the loan agreement.',
    },
    {
      question: 'How do I contact customer support?',
      answer: 'You can reach us at info@loanonsalary.com or visit our contact page for our helpline number and office address.',
    },
  ];

  return (
    <section className="faq-section py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold" style={{ color: '#052daa' }}>Frequently Asked Questions</h2>
          <p className="text-muted">Everything you need to know about our instant loan process.</p>
        </div>
        
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item border-0 mb-3 shadow-sm" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className={`accordion-button fw-semibold ${index !== 0 ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                  style={{ color: index === 0 ? '#052daa' : '#333' }}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body text-secondary">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;